(function() {
$(document).on('click', "[data-product-id] .order-qty-dropdown-menu li a", function(event) {
  var $btn_group, $button, $product_listing, _value;
  _value = $(event.target).data("qty");
  console.log("_value: " + _value);
  $btn_group = $(event.target).closest(".btn-group");
  $product_listing = $(event.target).closest("*[data-product-id]");
  $product_listing.attr("data-current-qty", _value);
  $button = $btn_group.find("button");
  return $button.find(".order_qty_value").text(_value);
});

$(document).on('click', ".add_product_to_online_order", function(event) {
  var $button, $container, $product_listing, _data, hire, product_id, products_url, qty;
  event.preventDefault();
  $container = $(event.target).closest(".buy_or_rent_button");
  hire = $container.data("hire");
  products_url = $(event.target).closest("*[data-products-url]").data("products-url");
  $product_listing = $(event.target).closest("*[data-product-id]");
  $button = $(event.target).closest('a');
  $button.addClass("disabled").text("adding...");
  qty = $product_listing.data("current-qty");
  product_id = $product_listing.data("product-id");
  console.log("product_id: " + product_id);
  _data = {
    product_id: product_id,
    qty: qty
  };
  if (hire) {
    _data.hire = true;
  }
  return $.post(products_url, _data, {
    dataType: "script"
  });
});

$(document).on('click', "[data-event-ticket-id] .order-qty-dropdown-menu li a", function(event) {
  var value;
  value = $(event.target).data("qty");
  $(event.target).closest("*[data-event-ticket-id]").attr("data-current-qty", value);
  return $(event.target).closest(".btn-group").find(".order_qty_value").text(value);
});

$(document).on('click', ".add_event_ticket_to_online_order", function(event) {
  var data, event_ticket_listing;
  event.preventDefault();
  event_ticket_listing = $(event.target).closest("*[data-event-ticket-id]");
  $(event.target).closest('a').addClass("disabled").text("adding...");
  data = {
    event_ticket_id: event_ticket_listing.data("event-ticket-id"),
    qty: event_ticket_listing.find("input[name='qty']").val()
  };
  return $.post(event_ticket_listing.data("event-ticket-url"), data, {
    dataType: "script"
  });
});

$(document).on('click', ".basket_item .order-qty-dropdown-menu li a", function(event) {
  var $btn_group, $button, $delete_control, $product_listing, $spinner, _data, _value, basket_url, left_offset, position, top_offset;
  _value = $(event.target).data("qty");
  console.log("basket_item: _value: " + _value);
  $btn_group = $(event.target).closest(".btn-group");
  $product_listing = $(event.target).closest(".basket_item");
  $product_listing.attr("data-current-qty", _value);
  $spinner = $("#spinner");
  $button = $btn_group.find("button");
  $delete_control = $product_listing.find(".basket_item_delete");
  position = $delete_control.offset();
  top_offset = 3;
  left_offset = 10;
  $spinner.css({
    position: "absolute",
    top: position.top + top_offset,
    left: position.left + $delete_control.width() + left_offset
  }).show();
  basket_url = $product_listing.data("basket-url");
  _data = {
    qty: _value
  };
  return $.ajax({
    url: basket_url,
    type: "PUT",
    data: _data,
    dataType: "script",
    error: function() {
      $spinner.hide();
      return alert("there was an error updating the basket");
    },
    success: function() {
      $spinner.hide();
      return $button.find(".order_qty_value").text(_value);
    }
  });
});

}).call(window);
